import { offlineApi } from '../../api/offline.js';
import { ReportBody } from './ReportPage.js';

/**
 * 오프라인 POS 마스터 (원본 offline_master.php).
 *
 * 오프라인(0P) 하위 카테고리를 노출순서대로 늘어놓고, 각 줄에서 그 카테고리의
 * POS 등록용 엑셀을 받는다. 표·정렬·검색은 정의 기반 리포트(offline-cate)가
 * 그대로 그리고, 원본에만 있던 내려받기 링크들을 여기서 얹는다 -
 * zaiko-stock 과 같은 방식이다.
 *
 * 원본과 달라진 점
 *   - 1번/2번 조각의 경계가 겹치지 않는다 (posExcel.service.ts 주석 참고)
 *   - '온라인 상품연결'은 원본 머리글이 스스로 "작업중/클릭금지"라고 적어 둔
 *     미완성 링크(offline_master_price_check.php)라, 누를 수 없게 막아 두었다
 */
export function OfflineCatePage() {
  return (
    <ReportBody
      reportId="offline-cate"
      headerExtra={
        <div className="toolbar">
          <span className="page-desc">POS 등록용 엑셀</span>
          <a className="btn btn--primary btn--sm" href={offlineApi.posExcelUrl()}>
            전체 다운로드
          </a>
          <a
            className="btn btn--ghost btn--sm"
            href={offlineApi.posExcelUrl({ slice: 1 })}
            title="전체를 둘로 나눠 받습니다 - 앞 8000줄"
          >
            1번
          </a>
          <a
            className="btn btn--ghost btn--sm"
            href={offlineApi.posExcelUrl({ slice: 2 })}
            title="전체를 둘로 나눠 받습니다 - 8000줄 뒤 전부"
          >
            2번
          </a>
        </div>
      }
      extraColumn={{
        label: '다운로드 / 온라인 상품연결',
        render: (row) => {
          const catecode = String(row.catecode ?? '');
          return (
            <div className="toolbar toolbar--tight">
              <a
                className="btn btn--ghost btn--sm"
                href={offlineApi.posExcelUrl({ catecode })}
                title={`${String(row.cname ?? '')} 카테고리만 받습니다`}
              >
                다운로드
              </a>
              <button
                type="button"
                className="btn btn--ghost btn--sm"
                disabled
                title="원본에서도 작업중이라 막혀 있던 기능입니다."
              >
                체크하기
              </button>
            </div>
          );
        },
      }}
    />
  );
}
